export default __webpack_public_path__ + "static/grafo-caea7acd1207e17969e6b86646d362c5.svg";